import ScrollManager from './ScrollManager'
import Hamburger from './Hamburger'
import AnchorScroll from './AnchorScroll'
import Accordion from './Accordion'
import AutoMovingSlides from './AutoMovingSlides'
import ReadMore from './ReadMore'
import Details from './Details'
import ChangeBackground from './ChangeBackground'

export default class {
  constructor() {

    const domMvAnimation = document.querySelector('[data-js="visual-animation"]');
    if (!domMvAnimation) {
      document.body.style.setProperty('--animation-val', '0');
      document.body.style.setProperty('--animation-val-bottom', '0');
    }

    const domScroller = document.querySelector('[data-scroller]');
    if (domScroller) new ScrollManager(domScroller);

    const domHamburger = document.querySelector('[data-js="trigger"]');
    if (domHamburger) new Hamburger(domHamburger);

    const domAnchorScroll = [...document.querySelectorAll('a[href^="#"]')];
    if ( domAnchorScroll ) {
      domAnchorScroll.forEach(el => {
        new AnchorScroll(el);
      });
    }

    const domAccordion = document.querySelectorAll('[data-js="accordion"]');
    if (domAccordion) {
      [...domAccordion].forEach(el=>{
        new Accordion(el);
      });
    }

    const domAutoMovingSlides = document.querySelectorAll('[data-js="auto-slide"]');
    if (domAutoMovingSlides) {
      [...domAutoMovingSlides].forEach(el=>{
        new AutoMovingSlides(el);
      })
    }

    const domReadMore = document.querySelectorAll('[data-js="readmore"]');
    if (domReadMore) {
      [...domReadMore].forEach(el=>{
        new ReadMore(el);
      })
    }

    const domDetails = document.querySelectorAll('details');
    if (domDetails) {
      [...domDetails].forEach(el=>{
        new Details(el);
      })
    }

    const domChangeBackground = document.querySelector('[data-js="background"]');
    if (domChangeBackground) new ChangeBackground(domChangeBackground);  
  }
}
